import { addQueryParams } from '../../../utils/url-utils';
export const attachJiraReferralIds = (href, ids) => {
  return addQueryParams(href, ids);
};